/**
 * <ReportConceptsCard> — the "NOTIONS ABORDÉES" block (organism, L0.1).
 *
 * A titled card listing one `<ReportConceptRow>` per subject, mirroring the legacy V1 block
 * (`LiveReportComponent:1038-1092`). Renders nothing when there is no group. Pure composition of
 * DS atoms/molecules. No hex.
 */
import React from "react"

import { Card } from "../../molecules/Card"
import { Stack } from "../../atoms/containers/Stack"
import { Text } from "../../atoms/typography/Text"
import { ReportConceptRow } from "../../molecules/ReportConceptRow"
import { type UILiveSessionReportConceptGroup } from "../../../ports/primary/ui/types"

export type ReportConceptsCardProps = {
    groups: UILiveSessionReportConceptGroup[]
    testID?: string
}

export function ReportConceptsCard(props: ReportConceptsCardProps) {
    const { groups, testID } = props

    if (groups.length === 0) return null

    return (
        <Card p="5" testID={testID}>
            <Stack gap="4">
                <Text size="text-xl" weight="bold">
                    NOTIONS ABORDÉES
                </Text>
                {groups.map((group, index) => (
                    <ReportConceptRow key={index} group={group} />
                ))}
            </Stack>
        </Card>
    )
}
